import Provider from 'preact-context-provider';
import {client} from '@core/GraphQLProvider';
import User from '@modules/User';
const UpiContextProvider = ( props ) =>
    <Provider
        client={client}
        user={{isLogged: User.isLogged(), salesChannel: User.getSalesChannel()}}
        conf={upi.conf}
        {...props}
    />;

export default UpiContextProvider;
